import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiEye, FiEyeOff, FiMail, FiLock, FiUser, FiArrowRight } from 'react-icons/fi';
// import AnimatedBackground from '../components/AnimatedBackground';

import { toast } from 'sonner';
import { validateInput } from 'helpers/inputValidator';
import Logo from 'assets/Logo.webp'
import { isValidEmail } from 'helpers/emailValidator';
import { useCooldownAction } from 'hooks/useCooldownAction';
import SmallLogo from 'assets/Logo.webp';
import apiUtils from 'utils/apiutils';

const Register = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    name: '',
    // username: '',
    email: '',
    password: '',
    confirmPassword: '',
    sponsor: searchParams.get('ref_by') || '',
    country: ''
  });
  const runWithCooldown = useCooldownAction();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [renderpage, setrenderpage] = useState(null)
  const [usernameError, setUsernameError] = useState("");
  const [loading, setloading] = useState(false)
  const [debouncedUsername, setDebouncedUsername] = useState(formData.email);
  const google_id = `${import.meta.env.VITE_GOOGLE_CLIENT_ID}`


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(formData.email?.toLowerCase())) {
      toast.error('Please enter a valid email address');
      return;
    }
    // Check if email is empty
    if (!formData.email.trim()) {
      toast.error('Email is required');
      return;
    }


    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    // Minimum length
    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    // Password strength regex:
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/;

    if (!strongPasswordRegex.test(formData.password)) {
      toast.error('Password must include uppercase, lowercase, number, and special character');
      return;
    }

    setloading(true)
    const payload = {
      // username: formData.username?.toLowerCase(),
      name: formData.name?.toLowerCase(),
      email: formData.email?.toLowerCase(),
      password: formData.password,
      confirm_password: formData.confirmPassword,
      sponsor: formData.sponsor,
      country: formData.country,
      registered_by: "manual",
      project_id: import.meta.env.VITE_PROJECT_ID
    };
    await runWithCooldown(async () => {
      try {
        const res = await apiUtils.post('/user/register', payload, {
          showToast: true,
          redirectUrl: '/',
        });

      } catch (error) {
        setloading(false)
      }
    })

  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow empty input to enable deletion/backspace
    if (value === "" || validateInput(name, value)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const checkusername = async (email) => {


    setUsernameError("");
    try {
      const payload = {
        email: email?.toLowerCase(),
      };

      const response = await apiUtils.post('/user/available_email', payload, {
        showToast: false,
      });

      if (!formData.sponsor) {

        setrenderpage(true);
        setUsernameError("Email is already taken");
        return;
      } else {
        setUsernameError("Email is already taken");
      }


    } catch (err) {
      setrenderpage(true);
     

        setUsernameError("");
      
    }
  };


  const checkuserid = async (userid) => {

    try {
      const payload = {
        userid: userid,
      };

      const response = await apiUtils.post('/user/available_userid', payload, {
        showToast: false,
      });
     


      if (response.Success) {

        setrenderpage(true);
        return;
      } else {
        setrenderpage(false);

      }


    } catch (err) {
      setrenderpage(true);

    }
  }

  const handleGoogleRegister = async (response) => {
    try {
      const idToken = response.credential;
      // Decode token to extract user info (or send token to backend for verification)
      const base64Url = idToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const decodedPayload = JSON.parse(atob(base64));


      const { email, name } = decodedPayload;

      const payload = {
        // username: email.split('@')[0],
        name: name.toLowerCase(),
        email: email.toLowerCase(),
        password: '', // placeholder or backend-generated
        confirm_password: '',
        sponsor: searchParams.get('ref_by') || '',
        country: '',
        registered_by: 'google',
        project_id: import.meta.env.VITE_PROJECT_ID,
        google_id_token: idToken, // send the token to your backend
      };

      const res = await apiUtils.post('/user/register', payload, {
        showToast: true,
        redirectUrl: '/',
      });

      if (res?.JWT) {
        localStorage.setItem('jwt', res.JWT);
        window.location.href = '/dashboard';
      }
    } catch (err) {

      console.error(err);
    }
  };

  // google register


  useEffect(() => {
    const renderGoogleButton = () => {
      const buttonDiv = document.getElementById('google-register-btn');
      if (window.google && buttonDiv) {
        window.google.accounts.id.initialize({
          client_id: google_id,
          callback: handleGoogleRegister,
        });

        window.google.accounts.id.renderButton(buttonDiv, {
          theme: 'filled_black',
          size: 'large',
          width: '100%',
          text: 'signup_with',
          shape: 'pill',
          logo_alignment: 'left',
        });
      }
    };

    // Retry until google.accounts.id and the div exist
    const interval = setInterval(() => {
      if (window.google?.accounts?.id && document.getElementById('google-register-btn')) {
        clearInterval(interval);
        renderGoogleButton();
      }
    }, 100);

    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, [google_id, handleGoogleRegister]);

  useEffect(() => {
    
    if(formData.sponsor === ''){

      setrenderpage(true);
    }else{
      checkuserid(formData.sponsor);

    }

    
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedUsername(formData.email);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [formData.email]);

  useEffect(() => {
    if (debouncedUsername) {
      checkusername(debouncedUsername);
    }
  }, [debouncedUsername]);

  ///

  return (
    <div className="min-h-screen flex items-center justify-center p-2 relative">
      {/* <AnimatedBackground /> */}

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md z-10"
      >
        <div className="card">


          {!showEmailForm && renderpage && (
            <div className=" max-w-md mx-auto p-6  rounded-2xl shadow-lg space-y-6">
              <div className="text-center">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className=" bg-gradient-primary rounded-full mx-auto mb-1 flex items-center justify-center"
                >
                  <img src={Logo} alt="" />
                </motion.div>
                <h1 className="text-3xl font-bold text-white mb-2">Create Account</h1>
                <p className="text-sm text-gray-400">Continue with your preferred method</p>
              </div>

              <div className="flex justify-center">
                <div id="google-register-btn" className="flex justify-center" />
              </div>

              <div className="relative flex items-center justify-center">
                <span className="w-full border-t border-gray-700" />
                <span className="px-3 text-sm text-gray-500 bg-gray-900 z-10">OR</span>
                <span className="w-full border-t border-gray-700" />
              </div>

              <div className="flex justify-center">
                <button
                  onClick={() => setShowEmailForm(true)}
                  className="w-full bg-gradient-to-r from-logiculustheme-neonBlue to-logiculustheme-colorDark text-white font-medium py-2 px-4 rounded-md flex items-center justify-center gap-2 hover:opacity-90 transition-all shadow"
                >
                  Signup with Email & Password
                </button>
              </div>
            </div>
          )}

          {showEmailForm && renderpage && (

            <form onSubmit={handleSubmit} className="space-y-6">
                <motion.div
                              initial={{ scale: 0 }}
                              animate={{ scale: 1 }}
              
                              className="bg-gradient-primary  rounded-full mx-auto mb-4 flex items-center justify-center"
                            >
                              <img src={SmallLogo} alt="" className='w-[250px]' />
                            </motion.div>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
              >
                <label className="block text-sm font-medium text-slate-300 mb-2">
                  Name
                </label>
                <div className="relative">
                  <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="input-field pl-10"
                    placeholder="Enter name"
                    required
                  />
                </div>
              </motion.div>

              {/* <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
              >
                <label className="block text-sm font-medium text-slate-300 mb-2">
                  Username
                </label>
                <div className="relative">
                  <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    className="input-field pl-10"
                    placeholder="Enter Username"
                    required
                  />

                </div>
                {usernameError && (
                  <p className="text-red-500 text-sm mt-1">{usernameError ? usernameError : ''}</p>
                )}
              </motion.div> */}

              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 }}
              >
                <label className="block text-sm font-medium text-slate-300 mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="input-field pl-10"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                {usernameError && (
                  <p className="text-red-500 text-sm mt-1">{usernameError ? usernameError : ''}</p>
                )}
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 }}
              >
                <label className="block text-sm font-medium text-slate-300 mb-2">
                  Password
                </label>
                <div className="relative">
                  <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="input-field pl-10 pr-10"
                    placeholder="Create a password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-300"
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6 }}
              >
                <label className="block text-sm font-medium text-slate-300 mb-2">
                  Confirm Password
                </label>
                <div className="relative">
                  <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="input-field pl-10 pr-10"
                    placeholder="Confirm your password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-300"
                  >
                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </motion.div>
              {formData.sponsor && (
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  <label className="block text-sm font-medium text-slate-300 mb-2">
                    Sponsor
                  </label>
                  <div className="relative">
                    <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                    <input
                      type="text"
                      name="sponsor"
                      value={formData.sponsor}
                      disabled
                      className="input-field pl-10"
                      placeholder="Enter Username"
                      required
                    />
                  </div>
                </motion.div>
              )
              }

              <motion.button
                disabled={loading}
                type="submit"
                className="w-full bg-primary p-3 rounded-xl text-secondary flex items-center justify-center gap-2"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >

                <>

                  {loading ? <span>Loading...</span> : "Create Account"}
                  <FiArrowRight />
                </>

              </motion.button>
            </form>
          )}

          {renderpage === null ? (
            // Loading State
            <div className="flex items-center justify-center min-h-[150px]">
            {/* <img src={SmallLogo} className='animate-spin w-28 h-28 ' alt="" /> */}
           <h1>Loading...</h1>
            </div>
          ) : !renderpage && (
            // No Sponsor Found
            <div className="flex items-center justify-center min-h-[150px] rounded-xl bg-gray-900 text-white shadow-lg border border-gray-700 p-6">
              <div className="text-center space-y-2">
                <div className="text-4xl">🚫</div>
                <h2 className="text-lg font-semibold">No Sponsor Name Found</h2>
                <p className="text-sm text-gray-400">Please check your referral or continue without a sponsor.</p>
              </div>
            </div>
          )}





          <div className="mt-8 text-center">
            <p className="text-slate-400">
              Already have an account?{' '}
              <Link
                to="/"
                className="text-logiculustheme-colorPrimary font-semibold transition-colors"
              >
                Sign in
              </Link>
            </p>
          </div>

        </div>
      </motion.div>
    </div>
  );
};

export default Register;

